import { orchestrator } from 'satcheljs';
import loadCLPUserLabels from '../actions/loadCLPUserLabels';
import initializeCLPStore from '../actions/initializeCLPStore';
import { makeGetRequest } from 'owa-ows-gateway';
import processCLPLabelResponse from '../service/processCLPLabelResponse';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logCLPLabelLoadDatapoint } from '../utils/logCLPDatapoints';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

const CLP_LABEL_ENDPOINT_URI = '/compliancepolicy/api/v1.0/user/label';
export let pendingLoadLabelPromise: Promise<void> = null;

orchestrator(loadCLPUserLabels, () => {
    if (isFeatureEnabled('cmp-clp') && !isConsumer()) {
        pendingLoadLabelPromise = makeGetRequest(CLP_LABEL_ENDPOINT_URI).then(resp => {
            initializeCLPStore(processCLPLabelResponse(resp));
            logCLPLabelLoadDatapoint(resp);
            pendingLoadLabelPromise = null;
        });
    }
});
